module.exports = __webpack_public_path__ + "media/images/icons/icon_more-f91dab795ff1f7f32dbffd5c2f8968b9.svg";